import { AndroidTVSettingsRepository } from "../../../../data/repository/androidTVSettings/AndroidTVSettingsRepository";
import { Message, Title, Url } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface AndroidTVSettingsChangeTitleUseCase {
  invoke: (title: Title) => Promise<ResponseState<Message>>;
}

export class AndroidTVSettingsChangeTitleUseCaseImpl
  implements AndroidTVSettingsChangeTitleUseCase
{
  private androidTVSettingsRepository: AndroidTVSettingsRepository;

  constructor(androidTVSettingsRepository: AndroidTVSettingsRepository) {
    this.androidTVSettingsRepository = androidTVSettingsRepository;
  }

  async invoke(title: Title): Promise<ResponseState<Message>> {
    try {
      let response = await this.androidTVSettingsRepository.changeTitle(title);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
